import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiService } from '../_base-http/base-api.service';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerService extends BaseApiService {
  constructor(
    private _http: HttpClient,
    private _stateService: StateService,
  ) {
    super(_http, _stateService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createCustomer(query: any) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.http.post<any>(`${this.baseApiUrl}customer/createcustomer`, query);
  }
}
